import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { contentsValueState, textState, titleValueState } from "../../../../atoms/atom";
import { deletetag } from "../../../../utils/CommonFunc";
import "./PopPageContents.scoped.scss";
interface IProps {
  textRef: React.ForwardedRef<string | any>;
  titleRef?: any;
  type: string;
}

function PopPageContents(props: IProps) {
  const { type, textRef, titleRef } = props;
  const { t } = useTranslation();
  const setText = useSetRecoilState(textState);
  const setTitleValue = useSetRecoilState(titleValueState);
  const contentsValue = useRecoilValue(contentsValueState);

  const onTitleChange = (e: React.ChangeEvent<HTMLDivElement>) => {
    let newValue = e.target.innerText;
    setTitleValue(newValue.slice(0, 30));
  };

  const keyPressEvent = (e: any) => {
    if (e.keyCode !== 8 && titleRef.current?.textContent?.length >= 30) {
      e.preventDefault();
    }
  };

  const onContentsChange = (e: React.ChangeEvent<HTMLDivElement>) => {
    setText(e.target.innerHTML);
  };

  return (
    <>
      {type === "write" ? (
        <div
          ref={titleRef}
          onInput={(e: React.ChangeEvent<HTMLDivElement>) => onTitleChange(e)}
          className="txt popTitle"
          contentEditable="true"
          placeholder={t("please_enter_title")}
          onKeyDown={keyPressEvent}
        />
      ) : null}
      <div
        ref={textRef}
        id="popConts"
        onInput={(e: React.ChangeEvent<HTMLDivElement>) => onContentsChange(e)}
        className="txt popContents"
        contentEditable="true"
        placeholder={t(type === "comments" ? "Please_leave_a_reply" : "what_are_you_going_to_write")}
        dangerouslySetInnerHTML={{
          __html: deletetag(contentsValue, ["img", "br"]) as string
        }}
      />
    </>
  );
}

export default PopPageContents;
